export enum TipoVuelo {
    Indeterminado = 0,
    Cabotaje = 1,
    Internacional = 2
}